module.exports = __webpack_public_path__ + "static/media/icon_insert_chart.12af35b5.svg";